import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, HeartPulse, Landmark } from 'lucide-react';
const benefits = [{
  icon: <ShieldCheck className="w-10 h-10 text-vitality-green" data-id="element-10" />,
  title: 'Ahorro que crece cada año sin pérdidas',
  description: 'Tu dinero está protegido contra las caídas del mercado. Participas en las ganancias, pero tu capital nunca disminuye por fluctuaciones económicas.'
}, {
  icon: <HeartPulse className="w-10 h-10 text-vitality-green" data-id="element-11" />,
  title: 'Protección financiera contra enfermedades graves',
  description: 'Accede a tus beneficios en vida si enfrentas una enfermedad crítica, crónica o terminal. Un respaldo económico cuando más lo necesitas.'
}, {
  icon: <Landmark className="w-10 h-10 text-vitality-green" data-id="element-12" />,
  title: 'Beneficios fiscales y liquidez a largo plazo',
  description: 'Disfruta de un crecimiento libre de impuestos y realiza retiros sin penalidades para complementar tu jubilación o cubrir emergencias.'
}];
export function Benefits() {
  return <section className="py-24 bg-light-bg relative" data-id="element-13">
      <div className="max-w-7xl mx-auto px-6" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-bold text-deep-blue mb-4" data-id="element-16">
            ¿Por qué elegir un IUL?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-17">
            La herramienta financiera más completa para asegurar el bienestar de
            tu familia mientras construyes un patrimonio sólido.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-18">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 group" data-id="element-19">
              <div className="mb-6 bg-green-50 w-16 h-16 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300" data-id="element-20">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-semibold text-deep-blue mb-3 leading-tight" data-id="element-21">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-22">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}